module.exports = __webpack_public_path__ + "img/click-complaint.a24d46c3.svg";